// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import { PropTypes } from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { formatAddress, isCanada } from '@tcp/core/src/utils';
import ClickTracker from '@tcp/web/src/components/common/atoms/ClickTracker';
import checkoutConstants from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import { convertHtml } from '@tcp/core/src/components/features/CnC/LoyaltyBanner/util/utility';
import Modal from '../../../molecules/Modal';
import Button from '../../../atoms/Button';
import Anchor from '../../../atoms/Anchor';
import TextBox from '../../../atoms/TextBox';
import BodyCopy from '../../../atoms/BodyCopy';
import AddressOption from '../../../molecules/AddressOption';
import Notification from '../../../molecules/Notification';
import styles from '../styles/AddressVerification.style';
import CONSTANTS from '../AddressVerification.constants';
import spacing from '../../../../../../styles/themes/TCP/spacing';
import {
  getLabelFromCopyOrFromTranslation,
  getLabelWithDefaultValue,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';
import AddEditAddresslabels, {
  GLOBAL_ADD_EDIT_ADDRESS_LABELS,
  lblAddEditAddressAddressLine2Label,
  lblAddEditAddressContinueCta,
  lblAddEditAddressEditAddress,
  lblAddEditAddressEntered,
  lblAddEditAddressInvalidApartmentNumber,
  lblAddEditAddressSuggest,
  lblAddEditAddressVerifyAddressLine2,
  lblAddEditAddressVerifyErrorsAddressLine2,
  lblAddEditAddressVerifyErrorsModalSubPremise,
  lblAddEditAddressVerifyHeader,
  lblAddEditAddressVerifyUseUnverifiedBtn,
} from '../../../../../utils/labels/globalAddEditAddress.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblUpdateCaps,
} from '../../../../../utils/labels/globalActions.labels';

export class AddressVerification extends React.Component {
  static propTypes = {
    heading: PropTypes.string.isRequired,
    className: PropTypes.string.isRequired,
    verificationResult: PropTypes.string.isRequired,
    userAddress: PropTypes.shape({}).isRequired,
    suggestedAddress: PropTypes.shape({}).isRequired,
    resetVerifyAddressAction: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    onError: PropTypes.func.isRequired,
    verificationResultCodes: PropTypes.string.isRequired,
    verifyAddressAction: PropTypes.func.isRequired,
    onEditAddressClick: PropTypes.func,
    dispatchReviewReduxForm: PropTypes.func.isRequired,
    cardType: PropTypes.string,
    fromReviewPage: PropTypes.bool,
    spc: PropTypes.bool,
    showIndicatorIcon: PropTypes.bool,
  };

  static defaultProps = {
    onEditAddressClick: () => {},
    cardType: '',
    fromReviewPage: false,
    spc: false,
    showIndicatorIcon: false,
  };

  constructor(props) {
    super(props);
    this.addEditAddressLabels = getLabelFromCopyOrFromTranslation(
      GLOBAL_ADD_EDIT_ADDRESS_LABELS,
      AddEditAddresslabels
    );
    this.state = {
      selectAddress: 'suggestedAddress',
      optionalAddressLine: '',
      optionalAddressLineError:
        getLabelWithDefaultValue(
          this.addEditAddressLabels,
          lblAddEditAddressVerifyErrorsAddressLine2
        ) || '',
    };

    this.isValidAddress = false;
    this.showInput = false;
    this.showVerifyModal = false;
    this.showOptionalAddressLine = false;
    this.isGenericError = false;
  }

  componentDidUpdate(prevProps, prevState) {
    const { fromReviewPage, verifyAdressLine2ErrorAction, addressLine2Error } = this.props;
    const { optionalAddressLine } = this.state;
    if (addressLine2Error && !this.isValidAddress && optionalAddressLine !== '') {
      this.setState({
        optionalAddressLineError:
          getLabelWithDefaultValue(
            this.addEditAddressLabels,
            lblAddEditAddressInvalidApartmentNumber
          ) || '',
      });
      verifyAdressLine2ErrorAction(false);
    }
    if (this.isValidAddress && (!fromReviewPage || prevState.optionalAddressLine)) {
      this.onConfirm();
    } else if (this.isError) {
      const { onError, userAddress } = this.props;
      onError(userAddress);
      this.onCloseModal();
    }
  }

  updateDisplayFlag = (verificationResult, userAddress, suggestedAddress) => {
    const { verificationResultCodes } = this.props;
    const { INVALID_CODES, GENERIC_CODES, OPTIONAL_ADDRESS_LINE, NO_ACTION_CODES } =
      CONSTANTS.VERIFY_ERROR_CODES_MAPPING;
    if (verificationResult) {
      const status = CONSTANTS.VERIFY_ADDRESS_STATUS_MAP[verificationResult];
      this.showOptionalAddressLine = verificationResultCodes.includes(OPTIONAL_ADDRESS_LINE);
      this.isValidAddress =
        NO_ACTION_CODES.find((code) => verificationResultCodes.includes(code)) ||
        !INVALID_CODES.find((code) => verificationResultCodes.includes(code));
      this.isGenericError = GENERIC_CODES.find((code) => verificationResultCodes.includes(code));
      this.showInput =
        (suggestedAddress &&
          !this.isValidAddress &&
          !this.showOptionalAddressLine &&
          !this.isGenericError) ||
        false;
      this.showVerifyModal = !this.isValidAddress || false;
      this.isError = status === CONSTANTS.VERIFY_ADDRESS_RESULT.ERROR;
    } else {
      this.showOptionalAddressLine = false;
      this.isValidAddress = false;
      this.showVerifyModal = false;
      this.showInput = false;
      this.isError = false;
    }
  };

  getMessage = (verificationResult) => {
    const { spc } = this.props;
    let message = renderLabel(
      this.addEditAddressLabels[`lbl_addEditAddress_errorMessage${verificationResult}`]
    );
    let status = '';
    if (this.isGenericError) {
      message = renderLabel(
        this.addEditAddressLabels[`lbl_addEditAddress_verifyMapping${this.isGenericError}`]
      );
      status = 'error';

      // Remove 'U.S' from the message if it exists in Canada site
      if (message?.includes('U.S') && isCanada()) {
        message = message?.replace(/U\.S/g, '');
      }
      message = message ? convertHtml(message) : '';
    } else if (this.showOptionalAddressLine) {
      message = renderLabel(
        this.addEditAddressLabels[lblAddEditAddressVerifyErrorsModalSubPremise]
      );
      status = 'error';
    }
    return this.isGenericError || this.showOptionalAddressLine ? (
      <Notification
        status={status}
        message={message}
        isErrorTriangleIcon
        isResetFontWeight
        spc={spc}
      />
    ) : (
      <div className="elem-mb-MED">
        <BodyCopy
          component="p"
          fontSize="fs14"
          textAlign={!spc ? 'center' : undefined}
          color={
            CONSTANTS.VERIFY_ADDRESS_STATUS_MAP[verificationResult] ===
            CONSTANTS.VERIFY_ADDRESS_RESULT.INVALID_ERROR
              ? 'error'
              : 'text.primary'
          }
          fontWeight={!spc ? 'extrabold' : undefined}
          fontFamily="secondary"
          data-locator="verifyaddress-msg"
        >
          {message}
        </BodyCopy>
      </div>
    );
  };

  onConfirm = () => {
    const { selectAddress, optionalAddressLine } = this.state;
    const { onSuccess, userAddress, suggestedAddress } = this.props;
    const { afterPayPayload } = this.props;
    const isOptionalAddressLineApplicable =
      selectAddress === 'suggestedAddress' ? false : optionalAddressLine;
    if (!afterPayPayload?.isMallisaFailed) {
      let addressPayload = {};
      if (!this.isGenericError && !this.showOptionalAddressLine && suggestedAddress) {
        const { validationCode } = suggestedAddress;
        addressPayload =
          selectAddress === 'userAddress' || isOptionalAddressLineApplicable
            ? Object.assign(addressPayload, { ...userAddress, validationCode })
            : Object.assign(addressPayload, {
                ...suggestedAddress,
                validationCode: CONSTANTS.VALID_CODES,
              });
      } else {
        const { validationCode } = suggestedAddress || {};
        addressPayload = Object.assign(addressPayload, {
          ...userAddress,
          ...(validationCode && { validationCode }),
        });
      }
      if (isOptionalAddressLineApplicable) {
        addressPayload.address2 = isOptionalAddressLineApplicable;
      }
      onSuccess(addressPayload);
    }
    this.onCloseModal();
  };

  onCloseModal = () => {
    const {
      resetVerifyAddressAction,
      dispatchReviewReduxForm,
      cardType,
      couponRemovedFromOrderFlag,
    } = this.props;

    const { optionalAddressLine, optionalAddressLineError } = this.state;
    if (optionalAddressLine || optionalAddressLineError) {
      this.setState({
        optionalAddressLine: '',
        optionalAddressLineError: '',
      });
    }

    if (cardType === checkoutConstants.APPLEPAY_LABEL && !couponRemovedFromOrderFlag) {
      dispatchReviewReduxForm();
    }
    resetVerifyAddressAction();
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      optionalAddressLineError: '',
    });
  };

  checkForAddressWarning = () => {
    const { AE01, AE08 } = CONSTANTS.ERROR_CODES;
    if (this.isGenericError) {
      switch (this.isGenericError) {
        case AE01:
          return 3;
        case AE08:
          return 2;
        default:
          return 1;
      }
    }
    return 0;
  };

  renderUserAddress = (verificationResult, userAddress) => {
    const { spc } = this.props;
    const { selectAddress } = this.state;
    const showWarning = this.checkForAddressWarning();
    let userEnteredAddressClass = this.showInput ? 'layout-pl-LRG' : 'layout-pl-XL';
    if (spc) {
      userEnteredAddressClass = '';
    }
    return (
      <div
        className={`addressVerification__section layout-pr-LRG elem-mb-XL ${userEnteredAddressClass}`}
      >
        <BodyCopy
          component="p"
          fontFamily="secondary"
          fontWeight={!spc ? 'extrabold' : 'bold'}
          fontSize="fs14"
          className="elem-mb-SM you-entered-lbl"
          data-locator="verifyaddress-youenteredlbl"
        >
          {getLabelWithDefaultValue(this.addEditAddressLabels, lblAddEditAddressEntered)}
        </BodyCopy>
        <div className="elem-mb-XL">
          <AddressOption
            className="addressVerification__input"
            address={formatAddress(userAddress)}
            name="selectAddress"
            value="userAddress"
            isSelected={selectAddress === 'userAddress'}
            onChange={this.handleChange}
            showInput={this.showInput}
            fontWeight={showWarning ? 'normal' : 'extrabold'}
            inputProps={{
              'data-locator': 'verifyaddress-enteredradio',
            }}
            showWarning={showWarning}
            spc={spc}
            showProminentWarning={showWarning}
          />
        </div>
      </div>
    );
  };

  renderSuggestedAddress = (verificationResult, suggestedAddress) => {
    const { spc, showIndicatorIcon } = this.props;
    if (this.showInput) {
      const { selectAddress } = this.state;
      return (
        <div
          className={`addressVerification__section addressVerification__section--noBorder ${
            !spc ? 'layout-pl-LRG' : ''
          } layout-pr-LRG`}
        >
          <BodyCopy
            component="p"
            fontFamily="secondary"
            fontWeight={!spc ? 'extrabold' : 'bold'}
            fontSize="fs14"
            className="elem-mb-SM"
            data-locator="verifyaddress-wesuggestlbl"
          >
            {getLabelWithDefaultValue(this.addEditAddressLabels, lblAddEditAddressSuggest)}
          </BodyCopy>
          <div className="elem-mb-XL">
            <AddressOption
              className="addressVerification__input"
              address={formatAddress(suggestedAddress)}
              name="selectAddress"
              value="suggestedAddress"
              isSelected={selectAddress === 'suggestedAddress'}
              onChange={this.handleChange}
              fontWeight="extrabold"
              inputProps={{
                'data-locator': 'verifyaddress-suggestedradio',
              }}
              showInput
              spc={spc}
            />
          </div>
        </div>
      );
    }
    if (this.showOptionalAddressLine) {
      const { optionalAddressLine, optionalAddressLineError } = this.state;
      return (
        <div
          className={`addressVerification__section addressVerification__section--noBorder elem-mb-XL ${
            !spc ? 'layout-pl-XL' : ''
          }`}
        >
          <TextBox
            input={{
              value: optionalAddressLine,
              onChange: this.handleChange,
              name: 'optionalAddressLine',
            }}
            enableSuccessCheck={false}
            label={getLabelWithDefaultValue(
              this.addEditAddressLabels,
              lblAddEditAddressAddressLine2Label
            )}
            placeholder={getLabelWithDefaultValue(
              this.addEditAddressLabels,
              lblAddEditAddressVerifyAddressLine2
            )}
            id="optionalAddressLine"
            dataLocator="verifyaddress-addressLine2InPopUp"
            showExplicitError={optionalAddressLineError}
            spc={spc}
            showIndicatorIcon={showIndicatorIcon}
            autoFocus
            fromAddressVerification
          />
        </div>
      );
    }

    return null;
  };

  submitAfterPay = () => {
    const { afterPayPayload, checkoutWithAfterPay } = this.props;
    if (afterPayPayload?.isMallisaFailed && !afterPayPayload?.isPayloadChanged) {
      checkoutWithAfterPay(afterPayPayload);
    }
  };

  renderContinueCTA = (showUnVerified) => {
    const { spc } = this.props;
    return showUnVerified ? (
      <Anchor
        fontSizeVariation="large"
        anchorVariation="primary"
        underline
        noLink
        target="_blank"
        handleLinkClick={(e) => {
          e.preventDefault();
          this.submitAfterPay();
          this.onConfirm();
        }}
      >
        {getLabelWithDefaultValue(
          this.addEditAddressLabels,
          lblAddEditAddressVerifyUseUnverifiedBtn
        )}
      </Anchor>
    ) : (
      <ClickTracker
        as={Button}
        className="addressVerification__cta"
        buttonVariation="variable-width"
        fill={showUnVerified ? 'RED' : 'BLUE'}
        onClick={() => {
          this.submitAfterPay();
          this.onConfirm();
        }}
        data-locator="verifyaddress-continuebtn"
        spc={spc}
      >
        {getLabelWithDefaultValue(this.addEditAddressLabels, lblAddEditAddressContinueCta)}
      </ClickTracker>
    );
  };

  reVerifyAddress = () => {
    const { optionalAddressLine } = this.state;
    if (optionalAddressLine) {
      const { verifyAddressAction, suggestedAddress } = this.props;
      const newAddress = {
        ...suggestedAddress,
        address2: optionalAddressLine,
        fromModalCTA: true,
      };
      verifyAddressAction(newAddress);
    } else {
      this.setState({
        optionalAddressLineError: getLabelWithDefaultValue(
          this.addEditAddressLabels,
          lblAddEditAddressVerifyErrorsAddressLine2
        ),
      });
    }
  };

  renderEditAddress = (showUnverified, onEditAddressClick) => {
    const { resetVerifyAddressAction, spc } = this.props;
    const { optionalAddressLine } = this.state;
    const onCLickEvent = () => {
      if (this.showOptionalAddressLine && showUnverified) {
        return this.reVerifyAddress;
      }
      return () => {
        onEditAddressClick();
        if (optionalAddressLine) {
          this.setState({
            optionalAddressLine: '',
          });
        }
        resetVerifyAddressAction();
      };
    };
    return (
      <Button
        role={spc && !showUnverified ? 'link' : 'button'}
        className={`addressVerification__cta ${
          spc && !showUnverified ? 'addressVerification__cta-err' : ''
        }`}
        buttonVariation="variable-width"
        onClick={onCLickEvent()}
        fill={showUnverified ? 'BLUE' : 'RED'}
        data-locator="verifyaddress-editaddressbtn"
        spc={spc}
      >
        {this.showOptionalAddressLine && showUnverified
          ? getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblUpdateCaps}`,
              GlobalActionsLabels
            )
          : getLabelWithDefaultValue(this.addEditAddressLabels, lblAddEditAddressEditAddress)}
      </Button>
    );
  };

  render() {
    const {
      className,
      verificationResult,
      userAddress,
      suggestedAddress,
      heading,
      onEditAddressClick,
      spc,
    } = this.props;
    this.updateDisplayFlag(verificationResult, userAddress, suggestedAddress);
    const showUnverified = this.isGenericError || this.showOptionalAddressLine;
    if (this.showVerifyModal) {
      return (
        <Modal
          colSet={{ large: 6, medium: 8, small: 6 }}
          isOpen
          onRequestClose={this.onCloseModal}
          overlayClassName="TCPModal__Overlay"
          className={`${className} TCPModal__Content TCPModal__Address`}
          heading={!spc ? heading : undefined}
          fixedWidth
          contentHeader={getLabelWithDefaultValue(
            this.addEditAddressLabels,
            lblAddEditAddressVerifyHeader
          )}
          maxWidth={spacing.MODAL_WIDTH.SMALL}
          heightConfig={{ maxHeight: '100%', height: 'auto' }}
          spc={spc}
        >
          <div className="addressVerification">
            <BodyCopy
              component="p"
              fontSize="fs22"
              fontWeight={!spc ? 'semibold' : 'bold'}
              fontFamily="secondary"
              textAlign="center"
              className={`elem-pt-LRG elem-mb-MED ${spc ? 'addressVerification__title' : ''}`}
            >
              {getLabelWithDefaultValue(this.addEditAddressLabels, lblAddEditAddressVerifyHeader)}
            </BodyCopy>
            {this.getMessage(verificationResult, suggestedAddress)}
            {this.renderUserAddress(verificationResult, userAddress, suggestedAddress)}
            {this.renderSuggestedAddress(verificationResult, suggestedAddress)}
            <div className="addressVerification__ctaContainer">
              {showUnverified ? (
                <>
                  {this.renderEditAddress(showUnverified, onEditAddressClick)}
                  {this.renderContinueCTA(showUnverified)}
                </>
              ) : (
                <>
                  {this.renderContinueCTA()}
                  {this.renderEditAddress(null, onEditAddressClick)}
                </>
              )}
            </div>
          </div>
        </Modal>
      );
    }

    return null;
  }
}

export default withStyles(AddressVerification, styles);
